<div class="modal-header main-modal-header">
    <button [hidden]="actionType === 'waitingParticipants' || actionType === 'joiningParticipant'" type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">
        <span>{{title}}</span>
    </h4>
</div>

<div class="modal-body">
    <div class="container">
        <app-invite-user-to-meeting *ngIf="actionType === 'inviteUsers'"
            [jobMatchObject]="jobMatchObject"
            [itemType]="scheduleType"
            [jobMatchId]="jobMatchId"
            [scheduleId]="scheduleId"
            (saveCallback)="closeModal()">
        </app-invite-user-to-meeting>
    </div>

    <!-- Approval for waiting participants -->
    <div class="container" *ngIf="actionType === 'waitingParticipants'">
        <div class="col-md-12 p-0">
            <form role="form" name="participantForm" #participantForm="ngForm" (ngSubmit)="participantForm.valid && allow()" novalidate>
                <p>The following participants are waiting for your approval to join.</p>
            <div *ngFor="let participant of waitingParticipants; let i = index">
                <div class="checkbox-nice">
                    <input type="checkbox" id="{{participant.participantId}}" [(ngModel)]="participant.isApproved" name="participantApproved{{i}}"
                        (change)="validateParticipant()"/>
                    <label class="license-pref-label" for="{{participant.participantId}}">
                        <span>{{participant.name}} </span>
                        <span *ngIf="participant.status == 'CANDIDATE_IN_WAIT'"> (Candidate)</span>
                    </label>
                </div>

            </div>
            <div class="alert alert-danger" *ngIf="displayNoSelectionMessage">
                No participant(s) selected
            </div>
            <div class="row">
                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger" (click)="disApproveParticipants()">
                            <span>Cancel</span>
                        </button>

                        <button type="submit" class="btn btn-success">
                            <span>Allow</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        </div>
    </div>

    <!-- Approval for joining participants -->
    <div class="container" *ngIf="actionType === 'joiningParticipant'">
        <div class="col-md-12 p-0">
            <p>{{joiningParticipant.name}}
                <span *ngIf="joiningParticipant.name.includes('CANDIDATE')">(Candidate)</span>
                <span>wants to join the meeting.</span>
            </p>
            <div class="row">
                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger mr-2" (click)="disApproveParticipants()">
                            <span>Cancel</span>
                        </button>

                        <button type="button" (click)="allowJoiningParticipant()" class="btn btn-success">
                            <span>Allow</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Enable feedback Edit for other users-->
    <div class="container" *ngIf="actionType === 'enableFeedbackEdit'">
        <div class="col-xs-12">
            <p>Please give another user access to edit the feedback.</p>
            <div *ngIf="usersToEditFeedback.length>0 && !loadingUsers" class="alert alert-info">
                <label for="participants">
                    <span *ngIf="readOnly">
                        Feedback can be edited by: <b>{{enabledEditForUser.displayName}}</b>. You can now leave the meeting.
                    </span>
                </label>
                <select *ngIf="!readOnly" class="form-control d-inline-block width-50" name="participants" id="participants" [ngModel]="enableEditForAttendeeId" (ngModelChange)="enableEditForAttendeeId = $event; onUserWhoCanEditFeedbackChange()" [disabled]="readOnly">
                    <option *ngFor="let user of usersToEditFeedback" value="{{user.attendeeId}}">{{user.displayName}}</option>
                </select>
                <i *ngIf="!readOnly" class="fas fa-redo" (click)="setFeedbackEnabledAttendeeId()" tooltip="Refresh users" container="body">
                </i>
            </div>
            <div class="alert alert-info d-flex justify-content-center fontsize" style="padding:24px" *ngIf="loadingUsers && feedbackDetails.usersToEditFeedback.length>0">
                <span class="fa fa-spinner fa-spin"></span>
            </div>
        </div>
        <div class="col-xs-12 text-right">
            <div class="clearfix">
                <button type="button" [disabled]="loadingUsers || enabledEditForUser.displayName == 'You'" (click)="confirmWhoCanEditFeedbackChangeAndLeave()" class="btn btn-primary">
                    <span>Approve &amp; Leave meeting</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Make a user primary host-->
    <div class="container" *ngIf="actionType === 'primaryHostChange'">
        <div class="col-xs-12">
            <p>Please make an another user the primary host.</p>
            <div *ngIf="usersToEditFeedback.length>0 && !loadingUsers" class="alert alert-info">
                <label for="participants">
                    <span *ngIf="readOnly">
                        <b>{{enabledEditForUser.displayName}}</b> is the primary host. You can now leave the meeting.
                    </span>
                </label>
                <select *ngIf="!readOnly" class="form-control d-inline-block width-50" name="participants" id="participants" [ngModel]="enableEditForAttendeeId" (ngModelChange)="enableEditForAttendeeId = $event; onPrimaryHostChange()">
                    <option *ngFor="let user of usersToEditFeedback" value="{{user.attendeeId}}">{{user.displayName}}</option>
                </select>
                <i class="fas fa-redo" *ngIf="!readOnly" (click)="setPrimaryHostAttendeeId()" tooltip="Refresh users" container="body">
                </i>
            </div>
            <div class="alert alert-info d-flex justify-content-center fontsize" style="padding:24px" *ngIf="loadingUsers && usersToEditFeedback.length>0">
                <span class="fa fa-spinner fa-spin"></span>
            </div>
        </div>
        <div class="col-xs-12 text-right">
            <div class="clearfix">
                <button type="button" [disabled]="loadingUsers || enabledEditForUser.displayName == 'You'" (click)="confirmPrimaryHostChangeAndLeave()" class="btn btn-primary">
                    <span>Approve and Leave meeting</span>
                </button>
            </div>
        </div>
    </div>
</div>
